module.exports = __webpack_public_path__ + "static/media/mir_white.565842a9.svg";